export default [
  {
    path: 'teacher-list',
    component: resolve => require(['@/components/learning-center/teacher/TeacherList'], resolve),
  },
  {
    path: 'create-teacher',
    component: resolve => require(['@/components/learning-center/teacher/CreateTeacher'], resolve),
  },
  {
    path: 'preview',
    component: resolve => require(['@/components/learning-center/teacher/Preview'], resolve),
  },
  {
    path: 'successful',
    component: resolve => require(['@/components/learning-center/teacher/Successful.vue'], resolve),
  },
  {
    path: 'teacher-detail/:teacher_id',
    component: resolve => require(['@/components/learning-center/teacher/TeacherDetail'], resolve),
  },
];




// WEBPACK FOOTER //
// ./src/router/modules/learning-center/teacher/index.js